import cn from 'classnames';
import OpText from 'components/Common/op-ui-wrappers/OpText/OpText';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import getCart from 'store/cart/selector/getCart';
import getCartNumberOfItems from 'store/cart/selector/getCartNumberOfItems';
import getIsCartItemsFetching from 'store/cart/selector/getIsCartItemsFetching';
import BasketItem from '../BasketItem/BasketItem';
import { BasketItemAttr } from '../BasketMain/types';
import styles from './BasketItems.module.scss';

interface BasketItemsProps {
  onRemoveItem: (orderItemId: number) => void;
  onEditItem: (orderItemId: number) => void;
  onChangeSelector: (orderItemId: number, attr: BasketItemAttr) => void;
}

const BasketItems: React.FC<BasketItemsProps> = ({ onRemoveItem, onEditItem, onChangeSelector }) => {
  const carts = useSelector(getCart);
  const fetchingOrderItems = useSelector(getIsCartItemsFetching);
  const itemsCount = useSelector(getCartNumberOfItems);
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <OpText variant="headline-small-bold">
          {t('txt_your_basket')}&nbsp;
          {itemsCount > 0 && <span>({itemsCount})</span>}
        </OpText>
      </div>
      <div
        className={cn(styles.cartItems, {
          [styles.loading]: fetchingOrderItems,
        })}
      >
        {carts.map((cart, cartIndex) => {
          if (!cart || !cart?.items) return '';
          return cart.items.map(
            (item) =>
              item && (
                <BasketItem
                  key={`i${cartIndex}_${item?.orderItemId}`}
                  item={item}
                  onRemoveItem={onRemoveItem}
                  onEditItem={onEditItem}
                  onChangeSelector={onChangeSelector}
                  loading={false}
                />
              ),
          );
        })}
      </div>
    </div>
  );
};

export default BasketItems;
